import React, { useState } from "react";
import { Menu, Spin, message } from "antd";
import { Button, Dropdown } from "antd";
import "./BusinessesActionMenu.module.css";
import { ArrowDownOutlined } from "@ant-design/icons";
import { useSearchParams } from "react-router-dom";
import { getBusinessesContactListServer } from "../../businessesApi";
import { readBusinessFiltersFromParams } from "../../utils/businessFilterParams";

export default function BusinessesActionMenu() {
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const menu = (
    <Menu>
      <Menu.Item
        onClick={downloadBusinessesContactList}
        icon={
          !loading ? (
            <ArrowDownOutlined />
          ) : (
            <span className="center">
              <Spin></Spin>
            </span>
          )
        }
        disabled={loading}
        key="action-1"
      >
        Export
      </Menu.Item>
    </Menu>
  );

  async function downloadBusinessesContactList() {
    try {
      setLoading(true);
      // Export the same set the list is currently filtered to (filters live in
      // the URL); the backend builds the CSV and returns a signed S3 URL.
      const filters = readBusinessFiltersFromParams(searchParams);
      const { url } = await getBusinessesContactListServer(filters);
      if (!url) {
        message.error("Export failed: no file was returned. Please try again.");
        return;
      }
      // Navigate to the signed S3 URL: the backend serves it with a
      // Content-Disposition: attachment header so it downloads in place, and
      // this can't be popup-blocked the way a post-await anchor click can.
      window.location.href = url;
    } catch (error) {
      console.error("Businesses export failed", error);
      message.error("Export failed. Please try again.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div>
      {" "}
      <>
        <Dropdown
          overlay={menu}
          placement="bottomLeft"
          arrow={{ pointAtCenter: true }}
        >
          <Button type="primary">Actions</Button>
        </Dropdown>
      </>
    </div>
  );
}
